import script from "./HistoryPaymentAdvisorComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./HistoryPaymentAdvisorComponent.vue?vue&type=script&setup=true&lang=js"

import "./HistoryPaymentAdvisorComponent.vue?vue&type=style&index=0&id=d7277744&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d7277744"]])

export default __exports__